import api from './api';

const secretaryService = {
  /**
   * Send audio to backend for transcription and task generation.
   * Uses FormData to send the audio file as multipart/form-data.
   *
   * @param {Blob} audioBlob - The recorded audio blob
   * @param {string} mimeType - The MIME type of the audio (e.g., 'audio/webm')
   * @returns {Promise<{transcription: string, task: {title, description, priority, project_code}}>}
   */
  processAudio: async (audioBlob, mimeType = 'audio/webm') => {
    const extension = mimeType.includes('webm') ? 'webm'
      : mimeType.includes('mp4') ? 'mp4'
      : mimeType.includes('ogg') ? 'ogg'
      : mimeType.includes('wav') ? 'wav'
      : 'webm';

    const formData = new FormData();
    formData.append('audio', audioBlob, `recording.${extension}`);

    const response = await api.post('/api/secretary/process-audio', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      timeout: 120000,
    });

    return response.data;
  },
};

export default secretaryService;
